"use strict";

var _createForOfIteratorHelper = require("E:\\FYP\\Portfolio\\Portfolio-Website-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("E:\\FYP\\Portfolio\\Portfolio-Website-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\FYP\\Portfolio\\Portfolio-Website-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Options = void 0;

var Interactivity_1 = require("./Interactivity/Interactivity");

var Particles_1 = require("./Particles/Particles");

var BackgroundMask_1 = require("./BackgroundMask/BackgroundMask");

var Background_1 = require("./Background/Background");

var Infection_1 = require("./Infection/Infection");

var Utils_1 = require("../../Utils");

var Options = /*#__PURE__*/function () {
  function Options() {
    _classCallCheck(this, Options);

    this.background = new Background_1.Background();
    this.backgroundMask = new BackgroundMask_1.BackgroundMask();
    this.detectRetina = true;
    this.fpsLimit = 30;
    this.infection = new Infection_1.Infection();
    this.interactivity = new Interactivity_1.Interactivity();
    this.particles = new Particles_1.Particles();
    this.pauseOnBlur = true;
  }

  _createClass(Options, [{
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (data === undefined) {
        return;
      }

      if (data.preset !== undefined) {
        if (data.preset instanceof Array) {
          var _iterator = _createForOfIteratorHelper(data.preset),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var preset = _step.value;
              this.importPreset(preset);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          this.importPreset(data.preset);
        }
      }

      var detectRetina = (_a = data.detectRetina) !== null && _a !== void 0 ? _a : data.retina_detect;

      if (detectRetina !== undefined) {
        this.detectRetina = detectRetina;
      }

      var fpsLimit = (_b = data.fpsLimit) !== null && _b !== void 0 ? _b : data.fps_limit;

      if (fpsLimit !== undefined) {
        this.fpsLimit = fpsLimit;
      }

      if (data.pauseOnBlur !== undefined) {
        this.pauseOnBlur = data.pauseOnBlur;
      }

      this.background.load(data.background);
      this.particles.load(data.particles);
      this.infection.load(data.infection);
      this.interactivity.load(data.interactivity);
      this.backgroundMask.load(data.backgroundMask);
      Utils_1.Plugins.loadOptions(this, data);
    }
  }, {
    key: "importPreset",
    value: function importPreset(preset) {
      this.load(Utils_1.Plugins.getPreset(preset));
    }
  }, {
    key: "fps_limit",
    get: function get() {
      return this.fpsLimit;
    },
    set: function set(value) {
      this.fpsLimit = value;
    }
  }, {
    key: "retina_detect",
    get: function get() {
      return this.detectRetina;
    },
    set: function set(value) {
      this.detectRetina = value;
    }
  }]);

  return Options;
}();

exports.Options = Options;